import React, { FC } from 'react';
import ReactTooltip from 'react-tooltip';
import './Tabs.scss';

interface Props {
  data: Array<{}>;
  currentTab: any;
  handlerClick: Function;
}

const Tabs: FC<Props> = ({ data = [], currentTab = {}, handlerClick = () => {} }) => {
  return (
    <div className="tabs">
      {data.length &&
        data.map((tab: any) => (
          <React.Fragment key={tab.value}>
            <div
              className={`tab ${currentTab?.value === tab.value ? 'active' : ''} ${tab?.disabled ? 'disabled' : ''}`}
              onClick={() => {
                if (!tab?.disabled) {
                  return handlerClick(tab);
                }
              }}
              data-tip
              data-for={tab?.disabled ? tab.value : ''}
            >
              {tab.name}
            </div>

            <ReactTooltip id={tab.value} type="warning" effect="solid">
              <span>{_t('Coming soon', 'TABS.COMING_SOON')}</span>
            </ReactTooltip>
          </React.Fragment>
        ))}
    </div>
  );
};

export default Tabs;
